import { Input } from "@mui/material";
import { useRunCallback } from "../../state/callbacks/callbacks";

interface CallbackInputProps {
  inputProps: unknown,
  field: string,
  callback: string,
}

const toInputProps = (inputProps: unknown): Record<string, unknown> => {
  if (!inputProps) {
    return {};
  }

  if (typeof inputProps === "string") {
    try {
      const parsed = JSON.parse(inputProps);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed)
        ? parsed as Record<string, unknown>
        : {};
    } catch {
      return {};
    }
  }

  return typeof inputProps === "object" && !Array.isArray(inputProps)
    ? inputProps as Record<string, unknown>
    : {};
};

/***
 * An input field that calls a callback function when the value changes.
 * Callback function must be added to the globalCallbacks object or the sharedState.callbacks object.
 */
export function CallbackInput({ inputProps, field, callback }: CallbackInputProps): React.ReactElement {
  const runCallback = useRunCallback();
  const safeInputProps = toInputProps(inputProps);
  const changeHandler: React.ChangeEventHandler<HTMLInputElement> = (event: any) => {
    runCallback(callback, { field, value: event.target.value });
  }
  return <Input {...safeInputProps} onChange={changeHandler} />
}